import { Autocomplete, Box, Button, Card, CardContent, Checkbox, FormControl, FormControlLabel, Grid2, InputLabel, MenuItem, Select, Slider, Tab, Tabs, TextField, Typography } from "@mui/material";
import { Container } from "./styles";
import CustomTabPanel, { a11yProps } from "../../components/customTabPanel";
import { useEffect, useState } from "react";
import Chat from "../../components/chat";

import AddIcon from '@mui/icons-material/Add';
import { initialStateAssistant, initialStateAssistantAutocomplete, marksTemperature } from "../../services/configAssistent";
import { GET_DATA, POST_DATA, PUT_DATA, SalvarLogErro } from "../../services/API";
import LoadingAll from "../../components/loadingAll";
import Swal from "sweetalert2";

import { useFormik } from "formik";
import * as Yup from 'yup';
import { AlertError } from "../../components/validation";
import { setDataAssistant } from "../../context/assistantSlice";
import { useDispatch, useSelector } from "react-redux";

import { v4 as uuidv4 } from 'uuid';
import { transformDatePtBR } from "../../utils";
import { Editor } from "@monaco-editor/react";

const cmOptions = {
    theme: "default",
    height: "auto",
    viewportMargin: Infinity,
    mode: {
        name: "javascript",
        json: true,
        statementIndent: 2
    },
    lineNumbers: true,
    lineWrapping: true,
    indentWithTabs: false,
    tabSize: 2
};

const ConfigAssistent = () => {
    const dispatch = useDispatch();
    const [value, setValue] = useState(0);
    const [assistants, setAssistants] = useState([{ id: 0, assistantId: '', label: 'Selecione um agente', disabled: true }]);
    const themeSelected = useSelector((state) => state.theme.dados.theme);
    const authentication = useSelector((state) => state.authentication);

    const [assistantAutocomplete, setAssistantAutocomplete] = useState(initialStateAssistantAutocomplete);

    const [loading, setLoading] = useState(false);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const [activeTab, setActiveTab] = useState(0);

    const handleChangeTabOptionAPI = (_event, newValue) => {
        setActiveTab(newValue);
    };


    useEffect(() => {
        try {
            //Buscar pelo agente selecionado
            if (loading) return;

            setLoading(true);

            (async () => {
                await fetchAssistants();
            })();

            const handleBeforeUnload = (event) => {
                event.preventDefault();
                event.returnValue = ""; // Necessário para exibir o alerta no navegador
            };

            // const handleKeyDown = (event) => {
            //     if ((event.ctrlKey && event.key === "r") || event.key === "F5") {
            //         event.preventDefault();
            //         alert("Não é possível recarregar a página para que evite perdas de dados");
            //     }
            // };

            window.addEventListener("beforeunload", handleBeforeUnload);
            // window.addEventListener("keydown", handleKeyDown);    

            return () => {
                window.removeEventListener("beforeunload", handleBeforeUnload);
                //window.removeEventListener("keydown", handleKeyDown);
            };
        }
        catch (err) {
            setLoading(false);
            SalvarLogErro('Iniciando agente', err);
        }
    }, []);

    const fetchAssistants = async () => {
        const result = await GET_DATA('Assistant/GetAllAssistantBasicData?flgActive=true');

        if (result !== null) {
            const options = [];

            result.data.map(item => {
                if (authentication.user?.login === 'fCamilo' && item.id === 2) {
                    options.push({
                        id: item.id,
                        label: item.name,
                        assistantId: item.assistantId,
                        disabled: false
                    });
                }
                else if (authentication.user?.login === 'admin') {
                    options.push({
                        id: item.id,
                        label: item.name,
                        assistantId: item.assistantId,
                        disabled: false
                    });
                }
            })


            setAssistants([{ id: 0, assistantId: '', label: 'Selecione um agente', disabled: true }, ...options]);
        }

        setLoading(false);
    }

    const handleNewAssistant = async () => {
        try {
            Swal.fire({
                backdrop: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                title: "Criar novo agente?",
                text: "Favor salvar qualquer edição que esteja fazendo antes de prosseguir, o formuário será limpo!",
                color: "#0d0e0e",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Prosseguir",
                cancelButtonText: "Não, Cancelar",
                confirmButtonColor: 'black',
                cancelButtonColor: '#F1416C'
            }).then((result) => {
                if (result.isConfirmed) {
                    setAssistantAutocomplete(initialStateAssistantAutocomplete);
                    formik.setValues(initialStateAssistant);
                }
                else {
                    Swal.fire({
                        title: "Cancelado!",
                        text: "Ação cancelada com suceso.",
                        icon: "success"
                    });
                }
            });
        }
        catch (err) {
            SalvarLogErro('handleNewAssistant', err);
        }
    }

    const handleChangeAssistante = async (assistantSelected) => {
        try {
            try {
                Swal.fire({
                    backdrop: true,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    title: "Altera o agente?",
                    text: "Ao alterar o agente caso tenha conversa no chat, as mesmas serão limpas e histórico perdido. Continuar?",
                    color: "#0d0e0e",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Continuar",
                    cancelButtonText: "Não, Cancelar",
                    confirmButtonColor: 'black',
                    cancelButtonColor: '#F1416C'
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        setLoading(true);

                        setAssistantAutocomplete(assistantSelected);

                        const result = await GET_DATA(`Assistant/GetAssistantById?id=${assistantSelected.id}`);
                        const data = result.data;

                        dispatch(setDataAssistant({ assistantId: data.assistantId, externalReference: uuidv4(), messages: [{ sender: "assistant", text: "Bem-vindo! Como posso te ajudar?", time: transformDatePtBR(new Date()) }] }));

                        const objAssistant = {
                            id: data.id,
                            name: data.name,
                            instructions: data.instructions.replace(/\\n/g, "\n"),
                            notInstructions: data.notInstructions.replace(/\\n/g, "\n"),
                            promptImage: data.promptImage.replace(/\\n/g, "\n"),
                            badWords: data.badWords?.replace(/\\n/g, "\n"),
                            model: data.model,
                            temperature: data.temperature,
                            flgActive: data.flgActive,
                            flgAPI: data.flgAPI,
                            assistantOld: data
                        };

                        if (data.flgAPI && data.customActions.length > 0) {
                            objAssistant.typeToken = data.customActions[0].typeToken;
                            objAssistant.token = data.customActions[0].token;
                            objAssistant.method = data.customActions[0].typeRequestId;
                            objAssistant.urlAPI = data.customActions[0].endpoint;
                            objAssistant.body = data.customActions[0].objectBody;
                            objAssistant.functions = data.customActions[0].objectFunctions;

                            const assistantOpenAi = JSON.parse(data.objectJson);

                            objAssistant.assistant = assistantOpenAi;
                        }

                        if (result !== null) {
                            formik.setValues(objAssistant);
                        }

                        setLoading(false);
                    }
                    else {
                        Swal.fire({
                            title: "Cancelado!",
                            text: "Ação cancelada com suceso. 1",
                            icon: "success"
                        });
                    }
                });
            }
            catch (err) {
                SalvarLogErro('Alterar o agente', err);
            }
        }
        catch (err) {
            setLoading(false);
            SalvarLogErro('Buscando agente por id', err);
        }
    }

    const handleRoolBack = async () => {

        if (assistantAutocomplete.id === 0) {
            Swal.fire({
                title: "Aviso!",
                text: "Favor selecionar o assistente.",
                icon: "warning"
            });
            return;
        }

        try {
            Swal.fire({
                backdrop: true,
                allowEscapeKey: false,
                title: "Fazer rollback dos dados salvos?",
                text: "Ao continuar todos os prompts serão alterados para a versão anterior.",
                color: "#0d0e0e",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Cotinuar",
                cancelButtonText: "Não, Cancelar",
                confirmButtonColor: 'black',
                cancelButtonColor: '#F1416C',

                showLoaderOnConfirm: true,
                preConfirm: async () => {
                    try {
                        const response = await PUT_DATA(`Assistant/RollBackLastVersiooPrompts?id=${assistantAutocomplete.id}`);
                        if (response === null) {
                            Swal.showValidationMessage("Ocorreu um erro ao fazer o rollback.");
                        }
                        else {
                            formik.resetForm();

                            setAssistantAutocomplete(initialStateAssistantAutocomplete);

                            await fetchAssistants();
                        }

                        return response;

                    }
                    catch (err) {
                        Swal.showValidationMessage(`Ocorreu um erro ao salvar o agente. <br /> ${err.message}`);
                        SalvarLogErro('handleRoolBack', err);
                    }
                },
                allowOutsideClick: () => !Swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        title: "Sucesso!",
                        text: "Rollback feito com sucesso.",
                        icon: "success"
                    });
                }
                else if (result.dismiss === Swal.DismissReason.cancel) {
                    Swal.fire({
                        title: "Cancelado!",
                        text: "Ação cancelada com suceso. 3",
                        icon: "success"
                    });
                }
            });
        }
        catch (err) {
            SalvarLogErro('handleRoolBack', err);
        }
    }

    const handleSave = async () => {
        try {
            Swal.fire({
                backdrop: true,
                allowEscapeKey: false,
                title: "Salvar os dados?",
                text: "Deseja prosseguir ao salvar os dados?",
                color: "#0d0e0e",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Salvar",
                cancelButtonText: "Não, Cancelar",
                confirmButtonColor: 'black',
                cancelButtonColor: '#F1416C',

                showLoaderOnConfirm: true,
                preConfirm: async () => {
                    try {
                        const assistantJsonSave = {
                            name: formik.values.name,
                            instructions: formik.values.notInstructions + "\n\n" + formik.values.notInstructions,
                            model: formik.values.model,
                            temperature: formik.values.temperature,
                            ToolsStr: formik.values.functions
                        }

                        formik.values.assistantOld.typeAssstentId = 1;

                        formik.values.assistantOld.name = formik.values.name;
                        formik.values.assistantOld.instructions = formik.values.instructions;
                        formik.values.assistantOld.notInstructions = formik.values.notInstructions;
                        formik.values.assistantOld.promptImage = formik.values.promptImage;
                        formik.values.assistantOld.flgActive = formik.values.flgActive;
                        formik.values.assistantOld.objectJson = JSON.stringify(assistantJsonSave);
                        formik.values.assistantOld.temperature = formik.values.temperature;
                        formik.values.assistantOld.flgAPI = formik.values.flgAPI;
                        formik.values.assistantOld.model = formik.values.model;
                        formik.values.assistantOld.flgActive = formik.values.flgActive;

                        if (formik.values.flgAPI) {
                            if (formik.values.assistantOld.customActions && formik.values.assistantOld.customActions.length > 0 && formik.values.assistantOld.customActions[0] != null) {
                                formik.values.assistantOld.customActions[0].typeRequestId = formik.values.method;
                                formik.values.assistantOld.customActions[0].endpoint = formik.values.urlAPI;
                                formik.values.assistantOld.customActions[0].typeToken = formik.values.typeToken;
                                formik.values.assistantOld.customActions[0].token = formik.values.token;
                                formik.values.assistantOld.customActions[0].objectBody = formik.values.body;
                                formik.values.assistantOld.customActions[0].objectFunctions = formik.values.functions;
                                formik.values.assistantOld.customActions[0].flgAPI = formik.values.flgAPI;
                                formik.values.assistantOld.customActions[0].flgActive = true;
                            }
                            else {
                                const objCustomAction = [{
                                    typeRequestId: formik.values.method,
                                    endpoint: formik.values.urlAPI,
                                    typeToken: formik.values.typeToken,
                                    token: formik.values.token,
                                    objectBody: formik.values.body,
                                    objectFunctions: formik.values.functions,
                                    flgAPI: formik.values.flgAPI,
                                    flgActive: true
                                }]

                                formik.values.assistantOld.customActions = objCustomAction;
                            }
                        }

                        delete formik.values.assistantOld.assistantConfig;

                        const response = await POST_DATA('Assistant/RegisterAssistent', formik.values.assistantOld);
                        if (response === null) {
                            Swal.showValidationMessage("Ocorreu um erro ao salvar os dados.");
                        }
                        else {
                            formik.resetForm();

                            setAssistantAutocomplete(initialStateAssistantAutocomplete);

                            await fetchAssistants();
                        }

                        return response;

                    }
                    catch (err) {
                        Swal.showValidationMessage(`Ocorreu um erro ao salvar o agente. <br /> ${err.message}`);
                        SalvarLogErro('handleSave', err);
                    }
                },
                allowOutsideClick: () => !Swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        title: "Sucesso!",
                        text: "Dados salvar com sucesso.",
                        icon: "success"
                    });
                }
                else if (result.dismiss === Swal.DismissReason.cancel) {
                    Swal.fire({
                        title: "Cancelado!",
                        text: "Ação cancelada com suceso. 3",
                        icon: "success"
                    });
                }
            });
        }
        catch (err) {
            SalvarLogErro('handleSave', err);
        }
    }

    const validationSchema = Yup.object().shape({
        name: Yup.string()
            .required("Nome é obrigatório"),
        instructions: Yup.string()
            .required("Instruções do que fazer é obrigatório"),
        urlAPI: Yup.string().test("url-valida", "Endpoint da API é obrigatório", (value, context) => {
            if (!context.parent?.flgAPI) return true;

            return context.parent?.flgAPI && value;
        })
    });

    const formik = useFormik({
        onSubmit: () => handleSave(),
        initialValues: initialStateAssistant,
        validationSchema: validationSchema,
        validateOnBlur: false,
        validateOnChange: false,
        enableReinitialize: false,
    });

    if (loading) {
        return <LoadingAll />
    }

    return !loading && formik.values != null && <Container>
        <div className="w-full border-divider flex flex-row items-center justify-center">
            <Tabs value={value} onChange={handleChange} sx={{ color: 'black' }}>
                <Tab style={{ fontWeight: 550, fontSize: 15, color: 'black' }} label={<Typography className="text-gray-700 dark:text-gray-300 mb-2 font-bold">Configuração de Agentes</Typography>} {...a11yProps(0)} wrapped />
            </Tabs>
        </div>
        <CustomTabPanel style={{ width: '100%', display: 'flex', alignItems: 'flex-start' }} value={value} index={0}>
            <form onSubmit={formik.handleSubmit} className="w" style={{ width: '100%' }}>
                <Grid2 container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }} style={{ width: '100%', marginTop: 15 }}>
                    <Grid2 className="bg-white dark:bg-gray-800 shadow-lg rounded-lg" size={{ xs: 12, md: 8 }}>
                        <Box className="w p-5 relative before:pointer-events-none">
                            <Box className="w">
                                <Typography className="text-gray-700 dark:text-gray-300 mb-2">Selecione o agente:</Typography>
                                <Box style={{ width: '100%', display: 'flex', flexDirection: 'row', paddingTop: 10 }}>
                                    <Autocomplete
                                        size="small"
                                        fullWidth
                                        className="w border-gray-300 dark:border-gray-600 rounded dark:bg-gray-700 dark:text-white"
                                        value={assistantAutocomplete}
                                        onChange={(e, valor) => {
                                            handleChangeAssistante(valor);
                                        }}
                                        getOptionDisabled={(option) => option.disabled}
                                        getOptionLabel={(option) => `${option.label}`}
                                        disablePortal
                                        options={assistants}
                                        sx={{ width: 300 }}
                                        renderInput={(params) => <TextField
                                            sx={{
                                                input: {
                                                    color: themeSelected === "dark" ? "white" : "black", // Altera a cor do texto digitado
                                                }
                                            }}

                                            className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded dark:bg-gray-700 dark:text-white"
                                            InputProps={{
                                                sx: { overflow: "auto", whiteSpace: "pre-line", color: 'white' }, // Garante que o conteúdo role corretamente
                                                className: "dark:text-white"
                                            }}
                                            inputProps={{
                                                style: { resize: "both", color: 'white' }, // Permite o redimensionamento manual
                                            }}
                                            {...params}
                                            label={<Typography className="text-gray-700 dark:text-gray-300 mb-2">Agentes</Typography>}
                                        />}
                                    />
                                    <Button size="small" style={{ marginLeft: 10, background: 'black', color: 'white' }} variant="contained" onClick={() => handleNewAssistant()}><AddIcon style={{ marginRight: 5 }} /> Novo</Button>
                                </Box>

                                <div className="w-[100%]">
                                    {/* <Autocomplet2 /> */}

                                </div>
                            </Box>
                            <Box className="w mt-10 flex flex-row items-center">
                                <Box className="w-4/5">
                                    <Typography className="text-gray-700 dark:text-gray-300 mb-2">Nome do agente:</Typography>
                                    <TextField
                                        size="small"
                                        sx={{
                                            input: {
                                                color: themeSelected === "dark" ? "white" : "black", // Altera a cor do texto digitado
                                            }
                                        }}
                                        fullWidth
                                        className="w-1/4 p-2 border border-gray-300 dark:border-gray-600 rounded dark:bg-gray-700 dark:text-white"
                                        variant="outlined"
                                        id="name"
                                        value={formik.values?.name}
                                        onChange={formik.handleChange}
                                    />
                                    <AlertError className="msg-error">{formik.errors.name}</AlertError>
                                </Box>
                                <FormControlLabel sx={{ marginLeft: 5, marginTop: 3 }} control={<Checkbox />} checked={formik.values.flgActive} onChange={() => formik.setFieldValue('flgActive', !formik.values.flgActive)} label={<Typography className="text-black dark:text-white">Ativo</Typography>} />
                            </Box>
                            <Box className="w flex flex-col" style={{ marginTop: 20 }}>
                                <Typography className="text-gray-700 dark:text-gray-300 mb-2" style={{ marginBottom: 10, fontWeight: 540 }}>Instruções que o agente deve seguir:</Typography>

                                <Editor
                                    height="60vh"
                                    defaultLanguage="text"
                                    defaultValue="// some comment"
                                    value={formik.values.instructions}
                                    onChange={(value) => formik.setFieldValue('instructions', value)}
                                    theme={themeSelected}
                                    style={{ resize: "both" }}
                                />

                                <AlertError className="msg-error">{formik.errors.instructions}</AlertError>

                                <Typography className="text-gray-700 dark:text-gray-300 mb-2" style={{ marginTop: 10, marginBottom: 10, fontWeight: 540 }}>Instruções que o agente não deve seguir:</Typography>
                                <Editor
                                    height="60vh"
                                    defaultLanguage="text"
                                    defaultValue="// some comment"
                                    value={formik.values.notInstructions}
                                    onChange={(value) => formik.setFieldValue('notInstructions', value)}
                                    theme={themeSelected}
                                    style={{ resize: "both" }}
                                />

                                <Typography className="text-gray-700 dark:text-gray-300 mb-2" style={{ marginTop: 10, marginBottom: 10, fontWeight: 540 }}>Prompt análise imagem:</Typography>
                                <Editor
                                    height="60vh"
                                    defaultLanguage="text"
                                    defaultValue="// some comment"
                                    value={formik.values.promptImage}
                                    onChange={(value) => formik.setFieldValue('promptImage', value)}
                                    theme={themeSelected}
                                    style={{ resize: "both" }}
                                />

                                <Typography className="text-gray-700 dark:text-gray-300 mb-2" style={{ marginTop: 10, marginBottom: 10, fontWeight: 540 }}>Palavras de baixo calão a serem barradas:</Typography>
                                <Editor
                                    height="20vh"
                                    defaultLanguage="text"
                                    defaultValue="// some comment"
                                    value={formik.values.badWords}
                                    onChange={(value) => formik.setFieldValue('badWords', value)}
                                    theme={themeSelected}
                                    style={{ resize: "both" }}
                                />

                                <Box className="w flex flex-row">
                                    <FormControl className="w-1/6 mt-5 mr-4" sx={{ marginTop: 4 }}>
                                        <InputLabel className="text-gray-700 dark:text-gray-300 mb-2" id="type-request">Modelo de treinamento</InputLabel>
                                        <Select
                                            labelId="modelo"
                                            value={formik.values.model}
                                            className="border-gray-300 dark:border-gray-600 rounded dark:bg-gray-700 dark:text-white"
                                            size="small"
                                            label="Modelo"
                                            id="model"
                                            defaultChecked={1}
                                            sx={{
                                                input: {
                                                    color: themeSelected === "dark" ? "white" : "black", // Altera a cor do texto digitado
                                                }
                                            }}
                                            onChange={(e) => formik.setFieldValue('model', e.target.value)}
                                        >
                                            <MenuItem value={'gpt-4o'}>GPT-4o</MenuItem>
                                            <MenuItem value={'gpt-4o-mini'}>GPT-4o-mini</MenuItem>
                                        </Select>
                                    </FormControl>

                                    <FormControlLabel className="text-gray-700 dark:text-gray-300 mb-2" sx={{ marginLeft: 5, marginTop: 3 }} control={<Checkbox />} checked={formik.values.flgAPI} onChange={() => formik.setFieldValue('flgAPI', !formik.values.flgAPI)} label="Conectar a uma API" />

                                    <Box className="w-1/3 pl-2 mt-2">
                                        <label className="mt-2 font-semibold text-gray-700 dark:text-gray-300 mb-2">Temepratura: {formik.values.temperature}</label>
                                        <Slider
                                            className="w-10 ml-3"
                                            sx={{ maxWidth: 400, color: 'black', marginTop: 1, color: themeSelected === "dark" ? "white" : "black" }}
                                            track={false}
                                            valueLabelDisplay="auto"
                                            value={formik.values.temperature || 0}
                                            id="temperature"
                                            onChange={(e, valor) => formik.setFieldValue('temperature', valor)}
                                            max={1}
                                            step={0.1}
                                            marks={marksTemperature}
                                        />
                                    </Box>

                                </Box>
                            </Box>
                            <Box className="w" style={{ marginTop: 20 }}>
                                {
                                    formik.values.flgAPI && <>
                                        <div className="w-[100%]">
                                            <hr className="w-[100%] mb-5" />
                                            <p className="font-bold mb-6 text-gray-700 dark:text-gray-300">Integração com Modelo</p>
                                        </div>
                                        <Box className="w" style={{ marginTop: 10, display: 'flex', flexDirection: 'row' }} sx={{ pointerEvents: !formik.values.flgAPI ? "none" : null, opacity: !formik.values.flgAPI ? 0.5 : 1 }}>
                                            <FormControl className="w-1/6 mr-4">
                                                <InputLabel className="text-gray-700 dark:text-gray-300 mb-2" id="type-request">Método</InputLabel>
                                                <Select
                                                    labelId="type-request"
                                                    id="typeRequestId"
                                                    className="border-gray-300 dark:border-gray-600 rounded dark:bg-gray-700 dark:text-white"
                                                    value={formik.values.typeRequestId}
                                                    size="small"
                                                    label="Método"
                                                    defaultChecked={1}
                                                    onChange={(e) => formik.setFieldValue('typeRequestId', e.target.value)}
                                                >
                                                    <MenuItem value={1}>POST</MenuItem>
                                                    <MenuItem value={2}>GET</MenuItem>
                                                    <MenuItem value={3}>PUT</MenuItem>
                                                    <MenuItem value={4}>DELETE</MenuItem>
                                                </Select>
                                            </FormControl>
                                            <Box className="w flex flex-col" sx={{ width: '100%' }}>
                                                <TextField
                                                    fullWidth
                                                    className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded dark:bg-gray-700 dark:text-white"
                                                    style={{ marginLeft: 10, width: '99%' }}
                                                    InputProps={{
                                                        sx: { color: themeSelected === "dark" ? "white" : "black" }, // Garante que o conteúdo role corretamente
                                                    }}
                                                    size="small"
                                                    id="urlAPI"
                                                    value={formik.values.urlAPI}
                                                    onChange={formik.handleChange}
                                                />
                                                <AlertError className="msg-error pl-4">{formik.errors.urlAPI}</AlertError>
                                            </Box>
                                        </Box>

                                        <Box className="w" style={{ marginTop: 10, display: 'flex', flexDirection: 'row' }} sx={{ pointerEvents: !formik.values.flgAPI ? "none" : null, opacity: !formik.values.flgAPI ? 0.5 : 1 }}>
                                            <Card className="p-4 w-full mx-auto bg-gray-100 dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded dark:text-white">
                                                <CardContent>
                                                    {/* Tabs */}
                                                    <Tabs value={activeTab} onChange={handleChangeTabOptionAPI} variant="fullWidth">
                                                        <Tab className="text-gray-700 dark:text-gray-300 mb-2" label="Headers" />
                                                        <Tab className="text-gray-700 dark:text-gray-300 mb-2" label="Body" />
                                                        <Tab className="text-gray-700 dark:text-gray-300 mb-2" label="Funções" />
                                                    </Tabs>

                                                    {/* Conteúdo da aba "Headers" */}
                                                    {activeTab === 0 && (
                                                        <Box className="mt-4 space-y-2">
                                                            <Box className="flex gap-2 items-center mb-5">
                                                                <TextField
                                                                    disabled
                                                                    className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded dark:bg-gray-700 dark:text-white"
                                                                    label={<Typography className="text-gray-700 dark:text-gray-300 mb-2">Key</Typography>}
                                                                    InputProps={{
                                                                        sx: { color: themeSelected === "dark" ? "white" : "black" }, // Garante que o conteúdo role corretamente
                                                                    }}
                                                                    value={'Content-type'}
                                                                    fullWidth
                                                                    size="small"
                                                                />
                                                                <TextField
                                                                    disabled
                                                                    className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded dark:bg-gray-700 dark:text-white"
                                                                    label={<Typography className="text-gray-700 dark:text-gray-300 mb-2">Value</Typography>}
                                                                    InputProps={{
                                                                        sx: { color: themeSelected === "dark" ? "white" : "black" }, // Garante que o conteúdo role corretamente
                                                                    }}
                                                                    value={'application/json'}
                                                                    fullWidth
                                                                    size="small"
                                                                />
                                                            </Box>
                                                            <Box className="flex gap-2 items-center mt-5">
                                                                <TextField
                                                                    className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded dark:bg-gray-700 dark:text-white"
                                                                    label={<Typography className="text-gray-700 dark:text-gray-300 mb-2">Key</Typography>}
                                                                    InputProps={{
                                                                        sx: { color: themeSelected === "dark" ? "white" : "black" }, // Garante que o conteúdo role corretamente
                                                                    }}
                                                                    id="typeToken"
                                                                    value={formik.values.typeToken}
                                                                    onChange={formik.handleChange}
                                                                    fullWidth
                                                                    size="small"
                                                                />
                                                                <TextField
                                                                    className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded dark:bg-gray-700 dark:text-white"
                                                                    label={<Typography className="text-gray-700 dark:text-gray-300 mb-2">Value</Typography>}
                                                                    InputProps={{
                                                                        sx: { color: themeSelected === "dark" ? "white" : "black" }, // Garante que o conteúdo role corretamente
                                                                    }}
                                                                    id="token"
                                                                    value={formik.values.token}
                                                                    onChange={formik.handleChange}
                                                                    fullWidth
                                                                    size="small"
                                                                />
                                                            </Box>
                                                        </Box>
                                                    )}
                                                    {
                                                        activeTab === 1 && (
                                                            <>
                                                                {/* <MonacoDiffEditor
                                                                    width="800"
                                                                    height="600"
                                                                    language="json"
                                                                    value={formik.values.body}
                                                                    onChange={(value) => formik.setFieldValue('body', value)}
                                                                /> */}

                                                                <Editor
                                                                    height="90vh"
                                                                    defaultLanguage="json"
                                                                    defaultValue="// some comment"
                                                                    value={formik.values.body}
                                                                    onChange={(value) => formik.setFieldValue('body', value)}
                                                                    theme={themeSelected}
                                                                />
                                                                <AlertError className="msg-error">{formik.errors.body}</AlertError>
                                                            </>
                                                        )
                                                    }
                                                    {
                                                        activeTab === 2 && (
                                                            <>
                                                                <Editor
                                                                    height="90vh"
                                                                    defaultLanguage="json"
                                                                    defaultValue="// some comment"
                                                                    value={formik.values.functions}
                                                                    onChange={(value) => formik.setFieldValue('functions', value)}
                                                                    theme={themeSelected}
                                                                />
                                                                <AlertError className="msg-error">{formik.errors.functions}</AlertError>
                                                            </>
                                                        )
                                                    }
                                                </CardContent>
                                            </Card>
                                        </Box>
                                    </>
                                }
                                <Box className="w flex flex-row justify-end" style={{ marginTop: 20 }}>
                                    <Button type="button" onClick={() => handleRoolBack()} variant="contained" sx={{ background: 'red', color: 'white', mr: 2, fontWeight: 'bold' }} size="medium">Rollback</Button>
                                    <Button type="submit" variant="contained" sx={{ background: 'black', color: 'white', fontWeight: 'bold' }} size="medium">Salvar</Button>
                                </Box>
                            </Box>
                        </Box>
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 4 }}>
                        <Chat />
                    </Grid2>

                </Grid2>
            </form>

        </CustomTabPanel>
    </Container>
}

export default ConfigAssistent;